import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-bottom-navbar',
  templateUrl: './bottom-navbar.component.html',
  styleUrls: ['./bottom-navbar.component.scss'],
})
export class BottomNavbarComponent implements OnInit {

  total_seconds = 0;
  is_running = false;
  date = null;
  interval;

  constructor(private cookieService: CookieService,private route: ActivatedRoute,public globalService: GlobalService) { 
    route.params.subscribe(val => {
      this.globalService.CheckTimer();
    });
  }
  ngOnInit() {
    
    
  }

  

}
